/**
 * Utility for consistent API error handling.
 * Parses errors from axios/fetch and returns a normalized Error.
 * @param {any} error - Original error object
 * @param {string} defaultMessage - Fallback error message
 * @returns {Error}
 */
export const handleApiError = (error, defaultMessage = 'An unexpected error occurred') => {
  let message = defaultMessage;

  if (error?.response) {
    message = error.response.data?.message || `${error.response.status} ${error.response.statusText}`;
  } else if (error?.message) {
    message = error.message;
  }

  console.error(message, error);
  return new Error(message);
};
